import BaseUI from "../base-ui.ts";
import LogoFragment from "../fragments/logo.ts";
import State from "../../state/state.ts";
import EatOutApiClient from "../../api-client/eat-out-api-client.ts";
import V1GroupCreated from "../../payloads/incoming/v1-group-created.ts";
import UiUtils from "../../utils/ui-utils.ts";
import Route from "../../enums/route.ts";
import LogUtils from "../../utils/log-utils.ts";

export default class MainMenuScreen extends BaseUI {
  constructor(
    state: State,
    apiClient: EatOutApiClient,
    navigateCallback: (route: Route) => void,
  ) {
    super("main-menu-screen", state, apiClient, navigateCallback);

    // subscribe to events
    this.apiClient.v1GroupCreatedCallback = this.handleV1GroupCreated.bind(this);

    // reset "current group" to nothing
    this.state.groupState.currentGroupId = null;
  }

  public override render(newElements: HTMLElement[] = []): HTMLDivElement {
    // logo
    const logo: LogoFragment = new LogoFragment(this.state, this.apiClient, this.navigateCallback);
    newElements.push(logo.render());

    // get the user's nickname and make sure it exists
    const nickname: string | null = this.state.userState.name;
    if (nickname === null) {
      LogUtils.error("attempted to render the MainMenuScreen, but the user's nickname was null");
    }

    // show the name of the user
    const nicknameParagraph: HTMLParagraphElement = UiUtils.paragraph(`Hello, ${nickname}!`);
    nicknameParagraph.id = "hello-nickname";
    newElements.push(nicknameParagraph);

    // join group button
    const joinGroupButton: HTMLButtonElement = UiUtils.button(
      "Join Group",
      () => this.navigateCallback(Route.JOIN_GROUP),
    );
    newElements.push(joinGroupButton);

    // create group button
    // TODO - only allowed during development
    // if (this.debug) {
    //
    // }
    const createGroupButton: HTMLButtonElement = UiUtils.button(
      "Create Group",
      () => this.apiClient.sendCreateGroupPayload(),
    );
    newElements.push(createGroupButton);

    // logout button
    const logoutButton: HTMLButtonElement = UiUtils.button("Logout", this.handleLogout.bind(this));
    newElements.push(logoutButton);

    return super.render(newElements);
  }

  private handleLogout(): void {
    LogUtils.debug(this.debug, "logging out");
    this.state.userState.id = null;
    this.state.userState.name = null;
    this.navigateCallback(Route.CHOOSE_NICKNAME);
  }

  private handleV1GroupCreated(v1GroupCreated: V1GroupCreated): void {
    LogUtils.debug(this.debug, "Successfully created a group.");

    // store the state of the Group we've just joined,
    // and mark it as the 'current group'
    this.state.groupState.addGroup(v1GroupCreated.payload.group);
    this.state.groupState.currentGroupId = v1GroupCreated.payload.group.id;

    // now that we have a group, switch to the Create Group Lobby screen
    this.navigateCallback(Route.CREATE_GROUP_LOBBY);
  }
}
